import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Container, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import IncomeSheet from './IncomeSheet';
import IncomeStatements from './IncomeStatements';
import IncomeGraph from './IncomeGraph';

export default function IncomeSheetTab() {

    const [value, setValue] = React.useState(0);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState();
    const [color, setColor] = useState();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 2 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }



    return (
        <Container>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mt={4} mb={1}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="success"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="full width tabs example"
                >
                <Tab
                 label="Visual"
                sx={{
                bgcolor: value === 0 && '#00bca4',
                border: value === 0 && '1px solid silver',
                borderRadius: value === 0 && '4px',
                textTransform: 'none'
                }}
                {...a11yProps(0)} />
                <Tab
                label="Income Sheet"
                sx={{
                    bgcolor: value === 1 && '#00bca4',
                    border: value === 1 && '1px solid silver',
                    borderRadius: value === 1 && '4px',
                    textTransform: 'none'
                    }}
                    {...a11yProps(1)} />
                <Tab
                label="Income Statement"
                sx={{
                    bgcolor: value ===2 && '#00bca4',
                    border: value === 2 && '1px solid silver',
                    borderRadius: value === 2 && 2,
                    textTransform: 'none'
                    }}
                {...a11yProps(2)}
                />
                </Tabs>
            </Box>

           

            <TabPanel value={value} index={0} >
              <IncomeGraph />
            </TabPanel>

            <TabPanel value={value} index={1} >
                <IncomeSheet setValue={setValue} />
            </TabPanel>

           
            <TabPanel value={value} index={2}>
            <IncomeStatements />
            </TabPanel>

        </Container>
    )
}
